import { initialSalesCallStatus, createSetters } from './setters';
import { createCallLifecycle } from './callLifecycle';
import { createAgentActions } from './agentActions';
import { createSummarizerActions } from './summarizerActions';

export type { SalesState, SalesActions } from './types';

export const createSalesModule = (set: any, get: any) => ({
  // Initial state
  salesCallStatus: initialSalesCallStatus,
  salesLoading: false,
  salesError: null,
  urgentHelpInFlight: false,
  checklistQuestionInFlight: null,
  digDeeperInFlight: false,
  objectionInFlight: false,
  isProcessingSummary: false,
  tourMode: false,
  tourDemoReady: false,
  tourBusinessInfo: null,
  tourActiveStepId: null,
  dashboardTourActive: false,
  spotlightTourActive: false,

  // Actions composed from all sub-modules
  ...createSetters(set, get),
  ...createCallLifecycle(set, get),
  ...createAgentActions(set, get),
  ...createSummarizerActions(set, get),
});
